<template>
  <div class="flex justify-center">
    <Form @submit="onSubmit" :validation-schema="schema" class="w-full">
      <Message v-if="error" severity="error">{{ error?._error || error?.message }}</Message>
      <Message v-if="loginError" severity="error">{{ loginError }}</Message>

      <BasicInputText type="email" name="email" :label="$t('your_email_address')" class="mb-3" />

      <BasicInputText name="password" :label="$t('your_password')" type="password" class="mb-3" />

      <div v-if="loading" class="text-center">
        <Progressspinner class="w-8 h-8 mb-3" />
      </div>

      <Button
        :disabled="loading"
        type="submit"
        severity="primary"
        :label="$t('sign_in')"
        icon="pi pi-user"
        class="w-full"
        rounded
      ></Button>
    </Form>
  </div>
</template>

<script setup lang="ts">
import * as yup from 'yup'
import { storeToRefs } from 'pinia'
import { Form } from 'vee-validate'

import Button from 'primevue/button'
import Progressspinner from 'primevue/progressspinner'
import Message from 'primevue/message'

import { useI18n } from 'vue-i18n'

import BasicInputText from './inputs/BasicInputText.vue'

import { useAuthStore } from '@/stores/auth'
import { useRequestStateStore } from '@/stores/request-state'

const authStore = useAuthStore()
const requestStateStore = useRequestStateStore()
const { t } = useI18n()

const { loginError } = storeToRefs(authStore)
const { loading, error } = storeToRefs(requestStateStore)

const schema = yup.object({
  email: yup
    .string()
    .required(t('validationErrorMessages.email_required'))
    .email(t('validationErrorMessages.invalid_email')),
  password: yup
    .string()
    .required(t('validationErrorMessages.password_required'))
    .min(8, t('validationErrorMessages.password_length_error'))
})

function onSubmit({ email, password }: any) {
  authStore.login(email, password)
}
</script>
